export default __webpack_public_path__ + "static/media/voxesLogo.498e6e1a.svg";